<template>
    <section :class="[panelClass,cname]">
    	<div class="content">
    		<h4><span @mouseenter="mouseEnterFun" :class="ani" @mouseleave="mouseLeaveFun">{{ title }}</span></h4>
        	<slot/>
    	</div>
    </section>
</template>

<script>
export default {
    props: {
        cname: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            panelClass: "panel",
            ani:'wow slideInDown'
        }
    },
    methods: {
		mouseEnterFun(){
//			this.ani='';
//			this.ani='wow bounceIn';
//			console.log('enter')
		},
		mouseLeaveFun(val){
//			this.ani='';
		}
	}
}
</script>

<style lang="less">
  @import "../../assets/css/common";
  .panel{
    .panel();
  }
</style>



// WEBPACK FOOTER //
// src/components/public/panel.vue